import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { APP_VERSION } from '../../tokens';
import { NgIf } from '@angular/common';

@Component({
    selector: 'pcp-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    imports: [NgIf]
})
export class VersionComponent implements OnInit, OnDestroy {
  constructor(
    public permissions: PermissionsService,
    private cd: ChangeDetectorRef,
    @Inject(APP_VERSION) public version: string
  ) {}

  shouldShow = false;
  private onDestroy$ = new Subject<void>();
  ngOnInit(): void {
    this.permissions
      .isAdministrator()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((v) => {
        this.shouldShow = !!this.version && v;
        this.cd.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
